<template>
  <b-card>
    <!-- Cabeçalho e descrição -->
    <!-- Cabeçalho com título à esquerda e botões à direita -->
    <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
      <!-- Lado esquerdo: Título e descrição -->
      <div
        class="mb-3 mb-md-0"
        style="max-width: 600px;"
      >
        <h4 class="mb-1">
          Atalhos Rápidos
        </h4>
        <p class="text-muted mb-0">
          Atalhos são respostas prontas que podem ser usadas para enviar rapidamente em uma conversa.
          Para criar uma resposta pronta, clique no botão <strong>“+ Adicionar Atalho”</strong>.
          Você também pode editar ou excluir um atalho da lista abaixo.
        </p>
      </div>

      <!-- Lado direito: Select de loja (condicional) e botão -->
      <div class="d-flex flex-column flex-md-row align-items-md-center">
        <b-form-select
          v-if="facebookAccountsLista.length > 1"
          v-model="chatSelecionado"
          :options="facebookAccountsLista.map(c => ({
            value: c.chat_token,
            text: c.name
          }))"
          size="sm"
          class="mb-2 mb-md-0 mr-md-2"
          style="min-width: 200px;"
          @change="carregarAtalhos"
        />
        <b-button
          variant="primary"
          size="sm"
          @click="abrirModalNovoAtalho"
        >
          + Adicionar Atalho
        </b-button>
      </div>
    </div>

    <hr>

    <!-- Lista de atalhos com scroll -->
    <div
      v-if="carregando"
      class="d-flex justify-content-center align-items-center py-5"
    >
      <b-spinner label="Carregando..." />
      <span class="ml-2 text-muted">Carregando atalhos...</span>
    </div>

    <div
      v-else
      style="max-height: 400px; overflow-y: auto;"
    >
      <b-list-group>
        <b-list-group-item
          v-for="(atalho, index) in atalhos"
          :key="atalho.id"
          class="atalho-item"
        >
          <div class="atalho-conteudo">
            <strong class="atalho-titulo">{{ atalho.atalho }}</strong>
            <span
              class="text-muted small atalho-texto"
              :title="atalho.texto"
            >{{ atalho.texto }}</span>
          </div>
          <div class="atalho-botoes">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="editarAtalho(index)"
            >
              <i class="feather icon-edit-2" />
              <span class="btn-text">Editar</span>
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              @click="removerAtalho(atalho.id)"
            >
              <i class="feather icon-trash-2" />
              <span class="btn-text">Excluir</span>
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>

    <!-- Modal para novo/editar -->
    <b-modal
      v-model="modalVisivel"
      :title="editandoIndice !== null ? 'Editar Atalho' : 'Novo Atalho'"
      hide-footer
    >
      <b-form @submit.prevent="salvarAtalho">
        <b-form-group label="Atalho (ex: /prazo)">
          <b-form-input
            v-model="novoAtalho.atalho"
            required
            placeholder="/atalho"
            maxlength="45"
          />
          <small class="text-muted d-block text-right">
            {{ (novoAtalho.atalho || '').length }}/45
          </small>
        </b-form-group>

        <b-form-group label="Texto da Mensagem">
          <b-form-textarea
            v-model="novoAtalho.texto"
            rows="3"
            required
            maxlength="1000"
          />
          <small class="text-muted d-block text-right">
            {{ (novoAtalho.texto || '').length }}/1000
          </small>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="fecharModal"
          >
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
          >
            {{ editandoIndice !== null ? 'Atualizar' : 'Salvar' }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  listarAtalhos,
  criarAtalho,
  editarAtalho,
  deletarAtalho,
} from '../../functions/basics/atalhos'
import { buscaChatsTeste } from '../../functions/basics/chat'

export default {
  name: 'AtalhosRapidos',
  data() {
    return {
      facebookAccountsLista: [], // lista de lojas retornadas
      chatSelecionado: null, // chat_token selecionado
      carregando: true,
      facebookAccounts: null,
      atalhos: [],
      modalVisivel: false,
      novoAtalho: {
        id: null,
        atalho: '',
        texto: '',
      },
      editandoIndice: null,
    }
  },
  async mounted() {
    this.facebookCredentials().then(() => {
      this.carregarAtalhos()
    })
  },
  methods: {
    async facebookCredentials() {
      const contas = await buscaChatsTeste()
      this.facebookAccountsLista = contas.chats || []

      if (contas.chats.length === 1) {
        this.chatSelecionado = contas.chats[0].chat_token
      } else if (contas.chats.length > 1) {
        this.chatSelecionado = contas.chats[0].chat_token // Seleciona a primeira por padrão
      } else {
        this.$bvToast.toast('Nenhuma loja encontrada.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
    async carregarAtalhos() {
      this.carregando = true
      try {
        const response = await listarAtalhos(this.chatSelecionado)
        const lista = response?.atalhos || response || []
        this.atalhos = lista.filter(a => a && a.id)
      } catch (err) {
        console.error('Erro ao listar atalhos:', err)
        this.atalhos = []
      } finally {
        this.carregando = false
      }
    },
    abrirModalNovoAtalho() {
      this.novoAtalho = { id: null, comando: '', texto: '' }
      this.editandoIndice = null
      this.modalVisivel = true
    },
    editarAtalho(index) {
      this.novoAtalho = { ...this.atalhos[index] }
      this.editandoIndice = index
      this.modalVisivel = true
    },
    async salvarAtalho() {
      const { atalho, texto, id } = this.novoAtalho

      if (!atalho.startsWith('/')) {
        this.$bvToast.toast('O atalho deve começar com "/".', {
          title: 'Atalho inválido',
          variant: 'warning',
          solid: true,
        })
        return
      }

      try {
        if (id) {
          await editarAtalho({ id, atalho, texto })
          this.$set(this.atalhos, this.editandoIndice, { id, atalho, texto })
        } else {
          const criado = await criarAtalho({ atalho, texto, chat_id: this.chatSelecionado })
          this.atalhos.push({ id: criado.id, atalho, texto })
        }

        this.fecharModal()
      } catch (err) {
        this.$bvToast.toast('Erro ao salvar o atalho.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
        console.error('Erro ao salvar atalho:', err)
      }
    },
    async removerAtalho(id) {
      try {
        await deletarAtalho(id)
        this.atalhos = this.atalhos.filter(a => a.id !== id)
      } catch (err) {
        this.$bvToast.toast('Erro ao excluir o atalho.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
        console.error('Erro ao deletar atalho:', err)
      }
    },
    fecharModal() {
      this.modalVisivel = false
      this.novoAtalho = { id: null, comando: '', texto: '' }
      this.editandoIndice = null
    },
  },
}
</script>

  <style scoped>
  /* Layout Desktop */
  .atalho-item {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 1rem;
  }

  .atalho-conteudo {
    flex: 1;
    min-width: 0;
    max-width: calc(100% - 200px);
  }

  .atalho-titulo {
    display: block;
    margin-bottom: 0.25rem;
  }

  .atalho-texto {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  .atalho-botoes {
    flex-shrink: 0;
    display: flex;
    gap: 0.5rem;
    margin-left: 1rem;
  }

  .atalho-botoes .btn i {
    margin-right: 0.25rem;
  }

  /* Layout Mobile - Cards */
  @media (max-width: 768px) {
    .atalho-item {
      flex-direction: column;
      padding: 1rem;
      border-radius: 0.5rem;
      margin-bottom: 0.75rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      background: white;
    }

    .atalho-conteudo {
      max-width: 100%;
      margin-bottom: 1rem;
    }

    .atalho-titulo {
      font-size: 1rem;
      color: #5e72e4;
      margin-bottom: 0.5rem;
    }

    .atalho-texto {
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
      line-height: 1.5;
      font-size: 0.875rem;
    }

    .atalho-botoes {
      width: 100%;
      margin-left: 0;
      gap: 0.5rem;
      justify-content: flex-end;
    }

    .atalho-botoes .btn {
      flex: 0 0 auto;
      padding: 0.5rem 1rem;
    }
  }

  /* Mobile Pequeno */
  @media (max-width: 480px) {
    .atalho-item {
      padding: 0.875rem;
      margin-bottom: 0.5rem;
    }

    .atalho-titulo {
      font-size: 0.9rem;
    }

    .atalho-texto {
      font-size: 0.8rem;
    }

    .atalho-botoes {
      flex-wrap: wrap;
    }

    .atalho-botoes .btn {
      font-size: 0.875rem;
      padding: 0.4rem 0.75rem;
    }

    .atalho-botoes .btn i {
      margin-right: 0.2rem;
      font-size: 0.875rem;
    }

    .btn-text {
      display: inline;
    }
  }

  /* Mobile Muito Pequeno - Apenas ícones */
  @media (max-width: 360px) {
    .atalho-botoes .btn {
      padding: 0.5rem;
      min-width: 40px;
    }

    .btn-text {
      display: none;
    }

    .atalho-botoes .btn i {
      margin-right: 0;
    }
  }

  /* Corrigir padding excessivo na página atalhos mobile */
  @media (max-width: 575.98px) {
    html[dir] body .app-content {
      padding: 0rem !important;
    }
  }
  </style>

  <style>
  @media (max-width: 575.98px) {
    html[dir] body .app-content {
      padding: 1rem 2rem 0rem 2rem !important;
    }
  }
  </style>
